import { render } from "./FuturesBalanceDeltaActionGraphWidgetLayout.vue?vue&type=template&id=4fc898f9"
import script from "./FuturesBalanceDeltaActionGraphWidgetLayout.vue?vue&type=script&lang=js"
export * from "./FuturesBalanceDeltaActionGraphWidgetLayout.vue?vue&type=script&lang=js"
script.render = render

export default script